class CommonUtil {
    
    dateFormat (d){        
      if(d == undefined || d == null){
        d = new Date();
      }
      var datestring = d.getFullYear() + "-" + this.lpad(d.getMonth()+1, 2) + "-" + this.lpad(d.getDate(), 2) + " " +
                        this.lpad(d.getHours(), 2) + ":" + this.lpad(d.getMinutes(), 2)+ ":" +  this.lpad(d.getSeconds(), 2) ;		
      return datestring;		
    }
    
    dateFormatMinute (d){        
      if(d == undefined || d == null){
        d = new Date();
      }
      var datestring = d.getFullYear() + "-" + this.lpad(d.getMonth()+1, 2) + "-" + this.lpad(d.getDate(), 2) + " " +
                        this.lpad(d.getHours(), 2) + ":" + this.lpad(d.getMinutes(), 2);		
      return datestring;		
    }

    dateFormatDate (d){	
      if(typeof d === 'string'){
        d = new Date(d);
      }
	    return d.getFullYear() + "-" + this.lpad(d.getMonth()+1, 2) + "-" + this.lpad(d.getDate(), 2);		
    } 
    
    lpad (str,length){      
      if(String(str).length >= length)
        return str;
      else
        return this.lpad("0" +String(str),length);
    }    
    isNull(obj){
      if(typeof obj === 'string'){
        if(obj != null && obj.trim() != ''){
          return false;
        }else {
            return true;
        }
      }else{
        if(obj == null || obj == '' || obj == 'null'){
          return true;
        }else{
          return false;
        }       
      }
    }
    
    arrToStr(arr){
      if(arr.length == 0){
        return '';
      }else{
        var str = '';
        for(var i =0; i< arr.length;i++){
          str = str + arr[i]+ ';';
        }
        return str;
      }
    }

    strToArr(str){
      if(this.isNull(str)){
        return [];
      }else{
        var a = str.split(';');
        var realColors = a.filter(function (e) {return (e != null && e != '');});        
        return realColors;
      }
    }

    checkDateDiff(sDate, eDate){
      var a = typeof sDate;
      var b = typeof eDate;
      debugger
      if(typeof sDate == 'string' && sDate.length >10){
        sDate = sDate.substr(0,10)
      }
      if(typeof eDate == 'string' && eDate.length >10){
        eDate = eDate.substr(0,10)
      }
    	var startDate = new Date(sDate);
	    var endDate = new Date(eDate);
	    var diff = ( endDate.getTime() - startDate.getTime()) / (60 * 60 * 1000 * 24);
     
      diff = diff.toFixed(0);
	    return diff;
    }

    setGroupSelectItem(data, select){
      let targetData = data;
      let tempArr = [];
      let tempLabel = '', cnt = 0;    
          
      targetData.forEach((item, index) => {       
        if( cnt!= 0 && item.type != tempLabel ){
          select.push({ label: tempLabel, options:tempArr });  
          tempArr = [];         
        }     
        cnt++;   
        tempLabel = item.type;  
        tempArr.push({ value: item.name });  
        if(targetData.length-1 == index){
          select.push({ label: tempLabel, options:tempArr });  
        }   
      });
      // var data = targetData.slice(targetData.length-1)[0];
      // select.push({ label: data.type, options:[{value:data.name}] });  
    }

    addDays (theDate, days) {    	    
	    return new Date(theDate.getTime() + days*24*60*60*1000);
    }
    

    
}





export default new CommonUtil();
